import { atom } from "recoil";

export const protocolType = atom({
  key: "protocolType",
  default: "",
});
// Full Scope

export const auditSwitchType = atom({
  key: "auditSwitchType",
  default: "",
});

export const switchProtocolType = atom({
  key: "switchProtocolType",
  default: "",
});

export const auditLoading = atom({
  key: "auditLoading",
  default: false,
});

export const scoringSubmit = atom({
  key: "scoringSubmit",
  default: false,
});
// Full Scope;
// Gap Assessment
// export const unitI

export const verisoningVersion = atom({
  key: "versioningVersion",
  default: 1,
});
